export default {
    '-': "-",
    actions: "Actions",
    actions_with_selected: "Actions with selected",
    active: "Active",
    add: "Add",
    add_attachment: "Add attachment",
    add_condition: "Add condition",
    afternoon: "Afternoon",
    all: "All",
    app_is_in_maintenance_mode: "The app is in maintenance mode, we'll be online soon",
    are_you_sure_you_want_to_delete: "Are you sure you want to delete material?",
    are_you_sure_you_want_to_logout: "Are you sure you want to logout?",
    assistant_id: "Assistant",
    authorization: "Authorization",
    authorize_in_system: "Authorize in the system ",
    azerbaijani: "Azerbaijani",
    balance: "Deposit",
    cancel: "Cancel",
    cancel_verb: "Cancel",
    change: "Change",
    change_password: "Change Password",
    comment: "Comment",
    confirm_deletion: "Confirm deletion?",
    contacts: "Contacts",
    contains: "Contains",
    continue: "Continue",
    credit: "Credit",
    currency: "Currency",
    custom_role_rights_updated: "Role rights updated",
    delete: "Delete",
    dentistry: "Dentistry",
    do_not_save: "Don't save",
    does_not_equal: "Does not equal",
    done: "Done",
    down: "Down",
    edit: "Edit",
    egisz_send_error: "EGISZ submission failed",
    egisz_send_success: "EGISZ submission succeeded",
    email: "E-mail",
    email_required_for_password_reset: "To reset this user's password, their email must be filled in",
    end: "End",
    english: "English",
    enter_username_to_reset_password: "Enter your username to receive a password reset link",
    equals: "Equals",
    error: "Error",
    error_message: "Something went wrong, the operation was not completed successfully",
    evening: "Evening",
    excel: "Excel",
    exported_patients_to_excel: "Uploaded patients into excel",
    exported_report_to_excel: "Exported report to excel",
    fact: "Fact",
    family_account_member_toggled: "Toggled family account member activity",
    family_account_updated: "Updated family account members",
    file: "File",
    file_does_not_exist: "File not found",
    file_size_is_too_big: "File size is too big",
    filled: "Filled",
    filled_not_signed: "Filled / not signed",
    filter: "Filter",
    finish: "Finish",
    finishing_operation: "Finishing operation",
    forgot_password: "Did you forget your Password?",
    from_to: "From {from} to {to}",
    general_cost: "Total cost",
    general_medicine: "General medicine",
    general_slogan: "Cloud solution for managing a modern clinic",
    hide: "Hide",
    hide2: "Hide",
    home: "Home page",
    image: "Image",
    import: "Import",
    in_interval: "In interval",
    input_field: "Text input field",
    integration: "Integration",
    invalid_reset_link: "This password reset link is invalid or has expired",
    kazakh: "Kazakh",
    kyrgyz: "Kyrgyz",
    KZT: "KZT",
    language: "Language",
    less: "Less",
    links: "Links",
    load_more: "Load more",
    logged: "Authorized",
    logged_out: "Logged out",
    login: "Login",
    login_disclaimer: "By continuing to sign in to DENTIST PLUS, you confirm that you are using your own account and accept responsibility for any actions performed using your credentials. Sharing your credentials with third parties is prohibited.",
    login_failed: "Failed login attempt",
    login_locked_out: "Login locked out (too many attempts)",
    login_or_pass_incorrect: "Login and/or password is incorrect",
    logout: "Logout",
    main: "Main",
    message: "Message",
    module_unavailable: "Module is unavailable",
    months: "Months",
    more: "More",
    more_2: "More",
    morning: "Morning",
    must_change_password_notice: "You must change your password to continue",
    name: "Name",
    new_password: "New Password",
    no: "No",
    no_data_available: "No data available yet",
    nonactive: "Inactive",
    not_enough_rights_for_this_operation: "Insufficient rights for this operation",
    not_filled: "Not filled",
    nothing_found: "No results found",
    old_password: "Old Password",
    on_page: "On Page",
    page_not_found: "Page not found",
    password: "Password",
    password_changed: "Password changed",
    password_confirm: "Confirm Password",
    password_reset_link_sent: "If an account with this username exists, a password reset link has been sent to its email",
    password_reset_failed: "Failed password reset attempt",
    password_reset_requested: "Requested a password reset",
    password_reset_succeeded: "Successfully reset password",
    passwords_do_not_match: "Passwords do not match",
    patient_search: "Patient search",
    patient_tags_updated: "Updated patient's tags",
    payment_expires_at: "Payment expires at",
    phone: "Telephone",
    photo: "Photo",
    price: "Price",
    print_noun: "Print",
    professional: "Professional",
    profile: "Profile",
    program: "Program",
    refresh: "Refresh",
    registration: "Registration",
    requirements: "Requirements",
    reset: "Reset",
    reset_password: "Password reset",
    reset_password_email_note: "The user will receive a link to their email to set a new password",
    reset_success: "A reset letter has been sent to your E-mail",
    role: "Role",
    russian: "Russian",
    save: "Save",
    search: "Search",
    select: "Select",
    send_reset_link: "Send Link",
    sent: "Sent",
    session_revoked: "Revoked a session",
    sessions_revoked: "Revoked all other sessions",
    settings: "Settings",
    show: "Show",
    show_full: "Show full",
    signin: "Sign in",
    slogan: "Cloud-based solution for managing modern dentistry",
    sorting: "Sorting",
    staff_rights_updated: "Staff rights updated",
    staff_role_updated: "Staff role updated",
    start: "Start",
    start_noun: "Start",
    status: "Status",
    subscription_sum: "Subscription sum",
    success_message: "Operation was successful",
    sum: "Amount",
    system: "Systemic",
    table_search: "Table look-up",
    tech_specialist: "Technical specialist",
    text: "Text",
    there_are_unsaved_changes: "There are unsaved changes",
    this_module_is_not_in_tariff: "This module is not included in the Free tariff, you need to connect Standard or Premium, and you will get access to a larger amount of functionality of the Dentist Plus program.",
    title: "Title",
    to_top: "To top",
    today: "Today",
    total: "Total",
    translation: "Translation",
    unknown: "Unknown",
    upload: "Upload",
    web: "Web",
    who_has_access: "Who has access",
    wrong_file_format: "Invalid file format",
    yes: "Yes"
}
